import React, { memo } from "react";
import { ReactComponent as InfoIcon } from "../../../assets/images/InfoIcon.svg";
import Tooltip from "../../UI/Tooltip";

import { Container, StyledLink, SubTitle } from "./styles";

const HeaderCartsMigrationInfo = ({ migration }) => {
  const sourceCart = migration?.source_store;
  const targetCart = migration?.target_store;
  const getDisplayCartName = (cart) => {
    if (cart === "UnknownCart") {
      return "Unknown";
    }
    return cart;
  };

  return (
    <Container>
      <SubTitle>{getDisplayCartName(sourceCart?.cart) || "Magento"}</SubTitle>
      {sourceCart?.url && (
        <Tooltip
          title={
            <StyledLink
              href={sourceCart.url}
              target="_blank"
              rel="noopener noreferrer"
            >
              {sourceCart.url}
            </StyledLink>
          }
          maxWidth={700}
          mouseLeaveDelay={0.5}
          color="white"
        >
          <InfoIcon />
        </Tooltip>
      )}

      <SubTitle> / </SubTitle>

      <SubTitle>{getDisplayCartName(targetCart?.cart) || "Shopify"}</SubTitle>
      {targetCart?.url && (
        <Tooltip
          title={
            <StyledLink
              href={targetCart.url}
              target="_blank"
              rel="noopener noreferrer"
            >
              {targetCart.url}
            </StyledLink>
          }
          maxWidth={700}
          mouseLeaveDelay={0.5}
          color="white"
        >
          <InfoIcon />
        </Tooltip>
      )}
    </Container>
  );
};

export default memo(HeaderCartsMigrationInfo);
